//import lozad from 'lozad';
import { runFunctions } from './_functions';
import { runBlocks } from './_blocks';

const { $ } = window;
const $body = $( document.body );

export default {
	init() {
		// const observer = lozad( `
		// 	.single-article-img img,
		// 	.cta-partner-research-image img
		// ` );
		// observer.observe();

		runFunctions();
		runBlocks();
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		// class to hide outlines if not using keyboard
		$body.on( 'mousedown', function() {
			$body.addClass( 'using-mouse' );
		} );
		$body.on( 'keydown', function() {
			$body.removeClass( 'using-mouse' );
		} );

		// header links, don't process click if url is #
		$('.header-links li a').each(function() {
			$(this).on('click', function(e) {
				if ($(this).attr('href') == '#') {
					e.preventDefault();
				}
			})
		})


		// insights
		if ($('body').hasClass('post-type-archive-insights')) {

			

			let types = [];
			let search = false;
			let sv = '';

			function loadCustomPosts() {

				var data = {
					action: 'load_custom_posts'
				};
		
				$.ajax({
					url: '/wp-content/themes/casana-theme/_ajax.php',
					data: data,
					type: 'POST',
					success: function(response) {
						if (response.success) {

							// load all post cards
							$('.archive-post-wrap').html(response.out_html);

							// show default post cards
							types.push('archive-post-default');
							showInsightsPosts('archive-post-default');
						} else {
							// Handle the error condition
							//console.log(response);
						}
					},
					error: function(xhr, status, error) {
						// Handle AJAX error
						//console.log(error);
						
					},
					complete: function() {
						
					}
				});
			}

			function showInsightsPosts() {
				// enable search form
				$('#tf-search-input').removeAttr('disabled');
				
					// hide all cards
				$('.archive-post-default').hide();
					
				let classes = types.map(x => '.'+ x).join(', ');
				let elem = $(classes);
				var visibleCount = 6;
				var increment = 6;
				let scat = [];
				let ctext;
				$('#sorter0 li.tf-selected-value').each(function() {
					scat.push($(this).text());
				});

				if (search) {
					$('.archive-post:not(.tf-search-result)').hide();
					ctext = scat.length > 1 ? 'categories' : '';
					if ($(elem).length) {
						
						$('#searchresults, #noposts').remove();
						$('.archive-post-wrap').prepend('<p id="searchresults">(' + $(elem).length + ') <strong>Search ' + ($(elem).length > 1 ? 'results' : 'result') + ' </strong> for "<strong>' + sv + '</strong>" in  ' + ctext + '<strong> ' + (scat.length >= 1 ? scat.join(', ') + '</strong>' : ' <strong>All Categories</strong>') + '</p>');
					} else {
						$('#searchresults, #noposts').remove();
						$('.archive-post-wrap').prepend('<p id="noposts">No results found for "<strong>' + sv + '</strong>" in '  + (scat.length ? ctext + ' <strong>' + scat.join(', ') : 'All Categories') + '.</p>');
					}
				} else {
					$('#search-results, #noposts').remove();
				}

				// show load more button if we need to
				if (elem.length > visibleCount) {
					$('.archive-load-btn-insights').delay((100 * visibleCount) + 100).fadeIn();
				} else {
					$('.archive-load-btn-insights').hide();
				}

				// Show initial set of cards
				elem.slice(0, visibleCount).each(function(index) {
					$(this).delay(100 * index).fadeIn(100);
				});

				 $('.archive-load-btn-insights').on('click', function() {

					if (types.length) {
						classes = types.map(x => '.'+ x).join(', ');
						elem = $(classes);
					}

				 	var hiddenCards = elem.filter(':hidden');

				 	// Check if there are more cards to show
				 	if (hiddenCards.length > 0) {
						var endIndex = (visibleCount + increment);

						// Show next set of cards
						elem.slice(visibleCount, endIndex).each(function(index) {
							$(this).delay(100 * index).fadeIn(100);
						});

						// Update the visible count
						visibleCount += increment;

						// Hide the "View More" button if there are no more cards
						 if (hiddenCards.length <= increment) {
						 	$('.archive-load-btn-insights').hide();
						 } else {
							$('.archive-load-btn-insights').show();
						 }
				 	}
				 });
			}

			function sortInsights(sort) {
				var container = document.getElementsByClassName('archive-post-wrap')[0];
				var cards = Array.from(container.getElementsByClassName('archive-post'));

				$(cards).hide();

				if (sort == 'latest') {
					cards.sort(function(a, b) {
						var dateA = parseInt(a.getAttribute('data-post-date'));
						var dateB = parseInt(b.getAttribute('data-post-date'));
						return dateA - dateB;
					});

					cards.reverse();
				}

				if (sort == 'alphabetic') {
					cards.sort(function(a, b) {
						var nameA = a.getAttribute('data-title').toLowerCase();
						var nameB = b.getAttribute('data-title').toLowerCase();

						if (nameA < nameB) {
							return -1;
						}
						if (nameA > nameB) {
							return 1;
						}
						return 0;
					});

					
				}

				// hide all cards
				$('.archive-post').remove();

				cards.forEach(function(card) {
					$(container).append(card);
				});

				showInsightsPosts();
			}
		
			
			// Call the AJAX function when the page has loaded
			loadCustomPosts();

			// insights category dropdown
			if ($('.tf-dropdown').length) {
				$('.tf-dropdown dd ul li').on('click', function() {
					
					let thisSorter = $(this).parent().parent().parent().parent();
					
					if (thisSorter.attr('id') != 'sorterx') {
						$(this).toggleClass('tf-selected-value');

							// reset search if they change categories
							search = false;
							sv = '';
							$('#tf-search-input').val('');
							$('#noposts, #searchresults').remove();



							types = [];
							if ($('#sorter0 .tf-selected-value').length) {
								
								$('#sorter0 .tf-selected-value').each(function() {
									if ($(this).data('key') != 'all') {
										types.push('archive-post-category-' + $(this).data('key'));
									} else {
										types.push('archive-post-default');
									}
								})
								
								
								
							} else {
								types.push('archive-post-default');
							}
						
					} else {
						$('#sorterx li').removeClass('tf-selected-value');
						$(this).toggleClass('tf-selected-value');
					}
					
					 	if($(this).parent().parent().parent().parent().attr('id') == 'sorterx') {
					 		// do this
					 		sortInsights($(this).data('key'));
					 	}


					 if (($(this).data('key') == 'all') || ($(this).parent().parent().parent().parent().attr('id') != 'sorterx')) {
					 	$('#sorterx').removeClass('tf-selected');
					 	$('#sorterx dt p').text('Sort By');
						$('#sorterx li.tf-selected-value').removeClass('tf-selected-value');
					 }

					showInsightsPosts();
				})
			}

			// debounce function prevents keyup from firing on every keypress and making errors when the script hasn't finished running.
			// instead, it fires keyup every 200ms
			function debounce(fn, duration) {
				var timer;
				return function(){
				  clearTimeout(timer);
				  timer = setTimeout(fn, duration);
				}
			  }

			// insights search
			$('#tf-search-input').on('keyup', debounce(() => {
				let searchvalue = $('#tf-search-input').val().toLowerCase();

				if (searchvalue.length && searchvalue.length >= 3) {
					search = true;
					sv = searchvalue;

					let cards = $('.archive-post-default');
					let categories = $('#sorter0 li.tf-selected-value');
					let searchcategories = [];

					if (categories.length) {
						categories.each(function() {
							searchcategories.push($(this).data('key'));
						})
					}
					
					cards.each(function() {
						if (
							($(this).find('h3').text().toLowerCase().indexOf(searchvalue) != -1)
						 || 
						 	($(this).data('post-content').toLowerCase().indexOf(searchvalue) != -1)
						){
							let thiscard = $(this);
							// if we are searching within categories, make sure this card has this category
							if (searchcategories.length) {
								$(searchcategories).each(function(ind, val) {
									if (thiscard.hasClass('archive-post-category-' + val) || val == 'all') {
										thiscard.addClass('tf-search-result');
									}
								});
							} else {
								$(this).addClass('tf-search-result');
							}
						} else {
							$(this).removeClass('tf-search-result');
						}
					});

					types = ['tf-search-result'];
					$('.archive-post').hide();
					showInsightsPosts();

				} else {
					search = false;
					sv = '';
					$('.archive-post-default').show();
					$('.archive-post-default').removeClass('tf-search-result');
					$('#noposts, #searchresults').remove();
				}
			}, 200));
		}

		if ($('.flp-articles-article').length) {
			
			$('.flp-articles-article').each(function(){
				$(this).css('max-height', $(this).find('.font5').height() + 50 + 'px');
			})

			const openTiming  = 300;
			const closeTiming = 300;
			let interacting = false;
			$('.flp-articles-article').on('click', function(e) {
				if (!e.target.classList.contains('flp-articles-article-content-container-right') && !$(e.target).is('svg')) {
					$(this).siblings().each(function() {
						$(this).animate({'max-height' : $(this).find('.font5').height() + 50 + 'px' }, closeTiming, 'swing', function() {
							//fade out, move down, fade in

							$(this).find('.flp-articles-article-content-container-middle').fadeOut(1).css('top', '1000px').fadeIn(1);
							
							$(this).find('.inner-wrap').css('background-position', '97% 5px');
							$(this).find('.m-md-only').css('display', 'none');
							$(this).css('cursor', 'pointer');
						});
						
					});


					
					$(this).find('.inner-wrap').css('background-position', '10000px center');
					$(this).find('.m-md-only').css('display', 'block');
					setTimeout(() => {
						$(this).find('.flp-articles-article-content-container-middle').css('top', '0');
						$(this).animate({'max-height': '850px'}, openTiming);
						$(this).css('cursor', 'auto');
					}, interacting ? closeTiming+50 : 0)
				}

				interacting = true
			})

			$('.flp-articles-article-content-container-right, .m-md-only, .m-md-only svg').on('click', function() {
				$(this).closest('.flp-articles-article').animate({'max-height': $(this).closest('.flp-articles-article').find('.font5').height() + 50 + 'px'}, 200, 'swing', function() {
					$(this).find('.inner-wrap').css('background-position', '97% 5px');
					$(this).find('.m-md-only').css('display', 'none');
					$(this).find('.flp-articles-article-content-container-middle').fadeOut(1).css('top', '200px').fadeIn(1);
					$(this).css('cursor', 'pointer');
				});
			})
		}

		// if ($('.flp-articles-article').length) {
		// 	$('.flp-articles-article a').on('click', function() {


		// 		// let content = $(this).next().find('.flp-articles-article-content');

		// 		//  // close all open
		// 		// //  $('.slide-toggle-open').each(function() {
		// 		// // 	$(this).slideUp(200);
		// 		// //  })

		// 		// //if (content.css('display'))

		// 		// // open this click
		// 		// if (content.css('display') == 'none') {	
		// 		// 	content.slideToggle(200, function() {}).addClass('slide-toggle-open');
		// 		// 	//content.prev().find('svg.flp-arrow').show()
		// 		// 	// get top position of article title
		// 		// 	// and top position of container
		// 		// 	if (window.innerWidth >= 768) {
		// 		// 		let attPos = content.prev().find('p.font5').offset().top;
		// 		// 		let thisPos = content.offset().top;

		// 		// 		// slide container up the different of the two top positions
		// 		// 		content.css('top', (thisPos - attPos) * -1 + 'px');	
		// 		// 	}
		// 		// } else  if (content.css('display') == 'block') {
		// 		// 	content.slideToggle(200, function() {
		// 		// 		if (window.innerWidth >= 768) {
		// 		// 			content.css('top', 'unset');
		// 		// 		}
		// 		// 	});
		// 		// }
				
		// 	});

			// $('.flp-articles-article-content-container-right').on('click', function() {
			// 	$(this).parent().parent().parent().parent().parent().parent().find('a.fillall').click();
			//  })

			 
		//}

		// press articles
		// if ( $( '.flp-articles-article' ).length ) {
		// 	$( '.flp-articles-article:not(.flp-articles-article-content-container)' ).each( function() {
		// 		$( this ).on( 'click', function( e ) {
		// 			if ( window.innerWidth >= 769 ) {
		// 				const titleTop = $( this ).find( '.flp-articles-article-title .font5' ).offset().top;
		// 				const titleHeight = $( this ).find( '.flp-articles-article-title' ).height();
		// 				const thisPos = $( this ).offset().top;
		// 				const posi = ( thisPos - ( titleTop + titleHeight ) );

		// 				$( this ).find( '.flp-articles-article-content-container' ).css( 'top', posi + 'px' ).css( 'margin-bottom', -Math.abs( posi ) + 'px' );
		// 				$( this ).find( '.body1' ).css( 'margin-top', Math.abs( posi ) + 'px' );
		// 			}

		// 			if ( ( $( e.target ).is( 'a' ) && $( e.target ).hasClass( 'fillall' ) ) || ( $( e.target ).is( 'div' ) && $( e.target ).hasClass( 'flp-articles-article-content-container-right' ) ) || $( e.target ).is( 'path' ) || $( e.target ).is( 'svg' ) ) {
		// 				// slide all up
		// 				$('.flp-articles-article').find('img').fadeOut(1);
		// 				$( '.flp-articles-article' ).removeClass( 'show' ).find( '.flp-articles-article-content' ).slideUp( 250 );

		// 				// detect to slide this click up or down
		// 				if ( $( this ).find( '.flp-articles-article-content' ).css( 'display' ) == 'block' ) {
		// 					$( this ).removeClass( 'show' );
		// 					$(this).find('.flp-articles-article-content-container-right').fadeOut(1);
		// 					$(this).find('.article-source-logo-container').fadeOut(1);
		// 					$(this).find('img').fadeOut(1, function() {
		// 						$( this ).find( '.flp-articles-article-content' ).slideUp( 150 );
		// 					});
		// 				} else {
		// 					$( this ).addClass( 'show' );
		// 						$( this ).find( '.flp-articles-article-content' ).slideDown( 150, function() {
		// 							$(this).find('.article-source-logo-container').fadeIn(1);
		// 							$(this).find('img').fadeIn(1);
		// 							if ( window.innerWidth >= 769 ) {
		// 							$(this).find('.flp-articles-article-content-container-right').fadeIn(1);
		// 						}
									
		// 						} );
							
		// 				}
		// 			}
		// 		} );
		// 	} );
		// }

		// slick sliders
		if ( $( '.studies-container' ).length ) {
			$( '.studies-container' ).each( function() {
				$( this ).slick( {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
					dots: false,
					fade: true,
					nextArrow: $( this ).parent().find( '.page-numbers.next' ),
					prevArrow: $( this ).parent().find( '.page-numbers.prev' ),
					//adaptiveHeight: true,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								adaptiveHeight: true,
							},
						},
					],
				} );

				// remove equal height per qa item
				//
				// $( this ).on( 'afterChange', function( ) { //event, slick, currentSlide, nextSlide ) {
				// 	if ( window.innerWidth >= 769 ) {
				// 		$( '.studies-block-container-left .slick-current' ).css( 'height', 'auto' );
				// 		$( '.studies-block-container-right .slick-current' ).css( 'height', 'auto' );
				// 		const leftHeight = $( '.studies-block-container-left .slick-current' ).height();
				// 		const rightHeight = $( '.studies-block-container-right .slick-current' ).height();
				// 		const maxHeight = Math.max( leftHeight, rightHeight );

				// 		$( '.slick-list' ).css( 'height', maxHeight + 90 + 'px' );
				// 		$( '.studies-block-container-left .slick-current' ).css( 'height', maxHeight + 90 + 'px' );
				// 		$( '.studies-block-container-right .slick-current' ).css( 'height', maxHeight + 90 + 'px' );
				// 	}
				// } );
			} );
		}

		// hover images on homepage should show hidden info on click
		if ($('.dcc-figure').length) {
			$('.dcc-figure').on('click', function() {
				$(this).css('opacity' == '0') ? $(this).css('opacity', '1') : $(this).css('opacity', '0');
			});
		}

		// partners block
		if ($('.partners-block-info-partners').length) {
			//  if (window.innerWidth >= 769) {
			//  	$('.partners-block-info-image img').height($('.partners-block-info-partners').height());
			//  } else {
			//  	$('.partners-block-info-image img').height('auto');
			//  }

			$('.partners-block-info-partners').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				prevArrow: $('.slick-prev'),
				nextArrow: $('.slick-next'),
				dots: false,
				fade: true,
				responsive: [
					{
					  breakpoint: 768,
					  settings: {
						adaptiveHeight: true
					  }
					}
				]
			})
		}

		window.onresize = function() {
			// if ( window.innerWidth >= 769 ) {
			// 	$( '.studies-block-container-left .slick-current' ).css( 'height', 'auto' );
			// 	$( '.studies-block-container-right .slick-current' ).css( 'height', 'auto' );
			// 	const leftHeight = $( '.studies-block-container-left .slick-current' ).height();
			// 	const rightHeight = $( '.studies-block-container-right .slick-current' ).height();
			// 	const maxHeight = Math.max( leftHeight, rightHeight );

			// 	$( '.slick-list' ).css( 'height', maxHeight + 90 + 'px' );
			// 	$( '.studies-block-container-left .slick-current' ).css( 'height', maxHeight + 90 + 'px' );
			// 	$( '.studies-block-container-right .slick-current' ).css( 'height', maxHeight + 90 + 'px' );
			// }

			if ($('.flp-articles-article').length) {
				$('.flp-articles-article').each(function(){
					if ($(this).css('max-height') != '850px') {
						$(this).css('max-height', $(this).find('.font5').height() + 50 + 'px');
					}
				})
			}

			//  if ($('.partners-block-info-partners').length) {
			//  	if (window.innerWidth >= 769) {
			//  		$('.partners-block-info-image img').height($('.pb-slide').height());
			//  	} else {
			//  		$('.partners-block-info-image img').height('auto');
			//  	}
			//  }

			if ($('.team-slider').length) {
				if ($('.team-arrows').length) {
					$('.team-arrows').css('top', ($('.team-slider-container-member img').height() / 2) - ($('.team-arrows-left').height()/2) + ($('.team-slider h2').outerHeight(true)) + 'px');
				}
			}

			// press articles
			// if ( window.innerWidth >= 769 ) {
			// 	if ( $( '.flp-articles-article.show' ).length ) {
			// 		$( '.flp-articles-article.show' ).each( function() {
			// 			const titleTop = $( this ).find( '.flp-articles-article-title .font5' ).offset().top;
			// 			const titleHeight = $( this ).find( '.flp-articles-article-title' ).height();
			// 			const thisPos = $( this ).offset().top;
			// 			const posi = ( thisPos - ( titleTop + titleHeight ) );

			// 			$( this ).find( '.flp-articles-article-content-container' ).css( 'top', posi + 'px' ).css( 'margin-bottom', -Math.abs( posi ) + 'px' );
			// 			$( this ).find( '.body1' ).css( 'margin-top', Math.abs( posi ) + 'px' );
			// 		} );
			// 	}
			// }

			
		};

		//dragging vs scrolling press articles
		if ($('.dragscroll').length) {
			let drag = false;
			let origlink;

			// e.prevent default will not work here
			// i think the dragscroll library sets a click function when scrolling is complete
			// so we set the target (.dragscroll a.fillall) a data-link with the original link
			// on mouseup, if a drag has occured, it's target is set to javascript: void(0);
			// if there is no drag, the regular href is set via data-link
			$('.dragscroll a.fillall').on('mousedown', function(e) {
				drag = false;
				e.target.href = e.target.dataset.link;
				$(this).on('mousemove', function() {
					drag = true;
				});
				$(this).on('mouseup', function(e) {
					if (drag) {
						e.target.href = 'javascript: void(0);';
						return;
					}
				});
			});
			
		}

		// team slider
		if ($('.team-slider-container').length) {

			if ($('.team-slider-toggle a').length) {
				$('.team-slider-toggle a').on('click', function() {
					let readMore = $(this).parent().prev('.team-slider-read-more');
					readMore.slideToggle(200, function() {
						//$(this).parent().parent().parent().parent().parent().parent().animate({'height': $(this).parent().parent().parent().height() + 'px'});
						//let maxHeight;
						if ($(this).css('display') == 'inline' || $(this).css('display') == 'block') {
							$(this).next().find('a').text('Read Less');
							$(this).prev().css('display', 'none');
							// three parents is slickactive
							// four parents is slick-track
							// five parents is slick-list
							// six parents is team-slider-container
							// there's gotta be a better way?  $(this).parent('.team-slider-container') didn't work
							//maxHeight = Math.max.apply(null, $(this).parent().parent().parent().parent().parent().parent().find('.slick-active').map(function ()
							//{
							//	return $(this).height();
							//}).get());
							//$(this).parent().parent().parent().parent().parent().parent().animate({'height': maxHeight + 'px'}, 200);
							$(this).css('display', 'inline');
							
						} else {
							$(this).next().find('a').text('Read More');
							$(this).prev().css('display', 'inline');
							//$(this).parent().parent().parent().parent().parent().parent().animate({'height': maxHeight + 'px'}, 200);
							$(this).css('display', 'none');
						}
					});
				});
			}

			$('.team-slider-container').each(function() {
				$(this).slick({
					arrows: true,
					dots: false,
					prevArrow: $(this).parent().find('.team-arrows-left'),
					nextArrow: $(this).parent().find('.team-arrows-right'),
					adaptiveHeight: true,
					slidesToShow: 3,
					slidestoScroll: 3,
					responsive: [
						{
							breakpoint: 992,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2
							},
						},
						{
							breakpoint: 640,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								adaptiveHeight: false
							}
						}
					]
				});

				// $(this).on('afterChange', function() {
				// 	var maxHeight = Math.max.apply(null, $(this).find('.slick-active').map(function ()
				// 	{
				// 		return $(this).height();
				// 	}).get());
					
				// 	$(this).animate({'height': maxHeight + 'px'}, 200);
				// })
				
			});

			
			if ($('.team-arrows').length) {
				$('.team-arrows').css('top', ($('.team-slider-container-member img').height() / 2) - ($('.team-arrows-left').height()/2) + ($('.team-slider h2').outerHeight(true)) + 'px');
			}
		}


		// heart seat slider
		if ($('.heart-seat-slider').length) {

			$('.heart-seat-link').on('click', function(e) {
				e.preventDefault();
				let $thisLink = $(this);

				// handle links
				$('.heart-seat-link').each(function() {
					$(this).removeClass('heart-seat-link-active');
				});
				$(this).addClass('heart-seat-link-active');

				// handle slides
					$('.heart-seat-slide-active').removeClass('heart-seat-slide-active');
					$('#heart-seat-slide-' + $thisLink.data('link-num')).fadeIn(250, function() {
						$('#heart-seat-slide-' + $thisLink.data('link-num')).addClass('heart-seat-slide-active');
					});


				//$('.heart-seat-slide-active').removeClass('heart-seat-slide-active').addClass('heart-seat-slide-not-active');
				//	$('#heart-seat-slide-' + $thisLink.data('link-num')).removeClass('heart-seat-slide-not-active');
					
				
			});

			
		}

		//attribute cards clicks
		if ($('.attribute-cards-card.has-external-link').length) {
			if (window.innerWidth <= 870) {
				$('.attribute-cards-card.has-external-link').on('click', function() {
					$(this).addClass('mobile-click-state');
				})
			}
		}


		//faqs
		if ($('.faqs-list-container-faq-top').length) {
			$('.faqs-list-container-faq-top').on('click', function(e) {
				// close open faq
				//if (window.innerWidth >= 640) {
					$('.faqs-list-container-faq.faq-show').toggleClass('faq-show').find('.faqs-list-container-faq-answer').slideToggle(200);
				//}
				
				if ($(this).parent().find('.faqs-list-container-faq-answer').css('display') == 'none') {
					$(this).parent().find('.faqs-list-container-faq-answer').slideToggle(200);
					$(this).parent().toggleClass('faq-show');

					//if (window.innerWidth <= 640) {
						//$(this).parent().scrollIntoView();
					//	$("html").animate(
					//		{
					//		  scrollTop: $(this).parent().offset().top - 100
					//		},
					//		250 //speed
					//	  );
					//}
				} else {
					//if (window.innerWidth <= 640) {
					//	$(this).parent().find('.faqs-list-container-faq-answer').slideToggle();
					//	$(this).parent().toggleClass('faq-show');
					//}
				}
			});
		}

		/**
		 * FAQs video section
		 */
		if ($('.faqs-video').length) {
			
			// observer
			const target = document.querySelector('.faqs-video');
			const options = {
				root: null,
				rootMargin: '0px',
				threshold: 0.1
			};
	
			const callback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						if ($('#faqs-video--video').length) {
							$('#faqs-video--video').attr('src', $('#faqs-video--video').attr('data-src'));
						}
						if ($('.faqs-video--question').length) {
							$('div.faqs-video--question').first().addClass('faqs-video--active');
						}
						observer.unobserve(target);
					}
				});
			};
	
			const observer = new IntersectionObserver(callback, options);
			observer.observe(target);


			// click handling
			if ($('.faqs-video--question').length) {
				$('.faqs-video--question').on('click', function() {
					if (!$(this).hasClass('faqs-video--active')) {
						$('.faqs-video--question').removeClass('faqs-video--active');
						$(this).addClass('faqs-video--active');
						$('#faqs-video--video').attr('src', $(this).attr('data-video'));
					}
				})
			}
		}
		
		

		// intersection observer on homepage
		if ( $( '.better-data-left' ).length ) {

			// only scroll images above tablet
				if (window.innerWidth >= 768) {
				const bdlHeight = $( '.better-data-left' ).height();
				let img1Scroll = 40;
				let img2Scroll = 100;
				let img3Scroll = 75;
				let img4Scroll = 100;

				if ( window.innerWidth <= 992 ) {
					img1Scroll = img1Scroll * 2;
					img2Scroll = img2Scroll * 2;
					img3Scroll = img3Scroll * 2;
					img4Scroll = img4Scroll * 2;
				}

				const img1 = document.getElementsByClassName( 'bd-image-1' )[ 0 ];
				const img2 = document.getElementsByClassName( 'bd-image-2' )[ 0 ];
				const img3 = document.getElementsByClassName( 'bd-image-3' )[ 0 ];
				const img4 = document.getElementsByClassName( 'bd-image-4' )[ 0 ];

				const target = document.querySelector( '.better-data-left' );
				function handleIntersection( entries ) {
					let imgs;
					entries.map( ( entry ) => {
					if ( entry.isIntersecting ) {
							imgs = entry.target.querySelectorAll( 'img' );
							window.onscroll = function() {
								const amountScrolled = $( '.better-data-left' ).position().top;
								const scrollPos = $( window ).scrollTop() + $( window ).height();
								const percentage = ( scrollPos - amountScrolled ) / bdlHeight;
								if ( percentage > 0.35 && percentage < 1.35 ) {
									const img1max1 = -( Math.abs( percentage * img1Scroll ) / 1440 ) * 100 + 'vw';
									const img1max2 = -Math.abs( percentage * img1Scroll ) + 'px';

									const img2max1 = -( Math.abs( percentage * img2Scroll ) / 1440 ) * 100 + 'vw';
									const img2max2 = -Math.abs( percentage * img2Scroll ) + 'px';

									const img3max1 = -( Math.abs( percentage * img3Scroll ) / 1440 ) * 100 + 'vw';
									const img3max2 = -Math.abs( percentage * img3Scroll ) + 'px';

									const img4max1 = -( Math.abs( percentage * img4Scroll ) / 1440 ) * 100 + 'vw';
									const img4max2 = -Math.abs( percentage * img4Scroll ) + 'px';

									//$('.bd-image-1').css('margin-top', 'max(' + -(Math.abs(percentage * img1Scroll) / 1440) * 100 + 'vw,', -Math.abs(percentage * img1Scroll) + 'px)');
									img1.style.marginTop = 'max(' + img1max1 + ', ' + img1max2 + ')';
									img2.style.marginTop = 'max(' + img2max1 + ', ' + img2max2 + ')';
									img3.style.marginTop = 'max(' + img3max1 + ', ' + img3max2 + ')';
									img4.style.marginTop = 'max(' + img4max1 + ', ' + img4max2 + ')';
								}
							};
						}
					} );
				}
				// const observer = new IntersectionObserver( handleIntersection );
				// observer.observe( target );
			}
		}

		/**
		 * modal on homepage
		 */
		function open_modal() {
			let modal = $('#pricing-modal');

			if (modal.length) {
				modal.addClass('pricing-modal-open');
			}
		}

		function close_modal() {
			let modal = $('#pricing-modal');

			if (modal.length) {
				modal.removeClass('pricing-modal-open');
			}
		}

		function doEventListeners() {
			let hero_button = $('.home .hero-full .btns-wrap .btn-primary');
			let close_button = $('.pricing-modal__close a');
			let shop_now = $('.meet-ss--container a.btn');
			let sub_bar_button = $('.home .subscription-bar-right a.btn, .the-smartseat .subscription-bar-right a.btn');
			
			if (hero_button.length) {
				hero_button.on('click', function(e) {
					e.preventDefault();
					open_modal();
				})
			}
			if (close_button.length) {
				close_button.on('click', function(e) {
					e.preventDefault();
					close_modal();
				})
			}
			if (shop_now.length) {
				shop_now.on('click', function(e) {
					e.preventDefault();
					open_modal();
				})
			}
			if (sub_bar_button.length) {
				sub_bar_button.on('click', function(e) {
					e.preventDefault();
					open_modal();
				})
			}
		}

		//doEventListeners();

		if (document.body.classList.contains('the-smartseat')) {
			const boxes = document.querySelectorAll('.bd-image-1');
			
			const observerOptions = {
				root: null,
				rootMargin: "0px",
				threshold: 0.25
			};
		
			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add('moved');
						observer.unobserve(entry.target);
					}
				});
			}, observerOptions);
		
			boxes.forEach(box => {
				observer.observe(box);
			});
		}
	},
};
